import { type PropsWithChildren } from 'react';

import { AnnotationsStoreProvider } from './AnnotationsStoreProvider.js';
import { AnnotationsTooltipConfigContext } from '../components/tooltip/contexts/AnnotationsTooltipConfigContext.js';
import type { AnnotationsTooltipConfig } from '../components/tooltip/types/annotations-tooltip-props.js';
import { AnnotationsActionsContext } from '../contexts/AnnotationsActionsContext.js';
import { AnnotationsMarkersInteractionContext } from '../contexts/AnnotationsMarkersInteractionContext.js';
import type {
  AnnotationsActionsHandler,
  AnnotationsMarkerInteractionsHandler,
} from '../types/annotations.js';

interface AnnotationsProvidersProps extends PropsWithChildren {
  onAnnotationsMarkersInteraction: AnnotationsMarkerInteractionsHandler;
  annotationsActions?: AnnotationsActionsHandler;
  tooltipConfig?: AnnotationsTooltipConfig;
}

export const AnnotationsProviders = ({
  children,
  onAnnotationsMarkersInteraction,
  annotationsActions,
  tooltipConfig,
}: PropsWithChildren<AnnotationsProvidersProps>) => (
  <AnnotationsMarkersInteractionContext.Provider
    value={onAnnotationsMarkersInteraction}
  >
    <AnnotationsActionsContext.Provider value={annotationsActions}>
      <AnnotationsTooltipConfigContext.Provider value={tooltipConfig}>
        <AnnotationsStoreProvider>{children}</AnnotationsStoreProvider>
      </AnnotationsTooltipConfigContext.Provider>
    </AnnotationsActionsContext.Provider>
  </AnnotationsMarkersInteractionContext.Provider>
);

AnnotationsProviders['displayName'] = 'AnnotationsProviders';
